import React from 'react'
import { ExcellentIcon, GoodIcon, FairIcon, PoorIcon, VeryPoorIcon } from './icons'

interface AssessmentScoreGaugeProps {
  level?: number
  maxLevel?: number
  width?: number
  height?: number
}

const AssessmentScoreGauge: React.FC<AssessmentScoreGaugeProps> = ({
  level = 1,
  maxLevel = 5,
  width = 84,
  height = 44,
}) => {
  const getSVG = () => {
    if (maxLevel === 5) {
      if (level === 5) {
        return <ExcellentIcon width={width} height={height} />
      } else if (level === 4) {
        return <GoodIcon width={width} height={height} />
      } else if (level === 3) {
        return <FairIcon width={width} height={height} />
      } else if (level === 2) {
        return <PoorIcon width={width} height={height} />
      } else if (level === 1) {
        return <VeryPoorIcon width={width} height={height} />
      }
    } else if (maxLevel === 3) {
      if (level === 3) {
        return <GoodIcon width={width} height={height} />
      } else if (level === 2) {
        return <FairIcon width={width} height={height} />
      } else if (level === 1) {
        return <PoorIcon width={width} height={height} />
      }
    }
    return null
  }

  return <div style={{ width, height }}>{getSVG()}</div>
}

export default AssessmentScoreGauge
